import { Component, computed, inject, input } from '@angular/core';
import { ParagraphPgPore } from '@app/models/paragraph.model';
import { BreakpointService } from '@app/services/breakpoint.service';
import { TeaserComponent } from '@app/components/teaser/teaser.component';
import { TextComponent } from '@app/components/text/text.component';
import {
  MobiUiExpanderComponent,
  MobiUiIconComponent,
} from '@mobi/rwc-ui-components-ng-jslib';
import { HeadingType, ProductReference } from '@app/models/global.model';
import { SplitButtonSectionComponent } from '@app/components/split-button-section/split-button-section.component';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { HeadingSelectComponent } from '@app/components/heading-select/heading-select.component';
import { CalcUrlPipe } from '@app/pipes/calc-url.pipe';

@Component({
  selector: 'mobi-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
  imports: [
    ComponentSharedModule,
    TeaserComponent,
    TextComponent,
    MobiUiIconComponent,
    MobiUiExpanderComponent,
    SplitButtonSectionComponent,
    HeadingSelectComponent,
    CalcUrlPipe,
  ],
  standalone: true,
})
export class RecommendationsComponent {
  readonly title = input();
  readonly description = input('');
  readonly recommendations = input.required<ParagraphPgPore[] | ProductReference[]>();

  recommendationItems = computed<string[]>(() => {
    if (!this.recommendations().length) return [];
    return this.recommendations().map((item) => item.tabLabel || '');
  });

  breakpoint = inject(BreakpointService);

  getTitleSize(recommendation: ParagraphPgPore | ProductReference): HeadingType {
    return (recommendation.titleSize as HeadingType) || 'h2';
  }

  getTeaserTitleSize(recommendation: ParagraphPgPore | ProductReference): HeadingType {
    if (recommendation.titleSize) {
      switch (recommendation.titleSize || 'h2') {
        case 'h2': {
          return 'h3';
        }
        case 'h3': {
          return 'h4';
        }
        default: {
          return 'h3';
        }
      }
    } else {
      return 'h3';
    }
  }
}
